import React from "react";
import Heading from "../Reuse/Heading";
import IncomeCard from "../Reuse/IncomeCard";
import { BsCurrencyDollar } from "react-icons/bs";
import { BsFillCalendarEventFill } from "react-icons/bs";

function MeetupEventIncome({ props }) {
  return (
    <>
      <div className="row">
        <Heading
          title={"Meetup Event"}
          icon={<BsFillCalendarEventFill size={50} />}
        />
        <IncomeCard
          title={"Total"}
          amount={props?.meetupTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Daily"}
          amount={props?.meetupDailyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Weekly"}
          amount={props?.meetupWeeklyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Monthly"}
          amount={props?.meetupMonthlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Yearly"}
          amount={props?.meetupYearlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default MeetupEventIncome;
